import { OnboardingNodeType, OnboardingStepType } from '../steps/types';
import { OnboardingSteps } from '../types';

const isSkipped = (
  nodeType: OnboardingNodeType,
  stepType: OnboardingStepType,
  steps: OnboardingSteps
) => {
  const onboardingSteps = steps[nodeType];

  if (!onboardingSteps) {
    return false;
  }

  const target = onboardingSteps.find((step) => step.uid === stepType);
  if (!target) {
    return false;
  }

  return target.skipped;
};

export default isSkipped;
